import logo from "assets/svg/logo.svg";
import {
  FacebookFilledIcon,
  InstagramFilledIcon,
  XTwitterIcon,
} from "assets/icons";

// Footer Component
export default function Footer() {
  return (
    <footer className="flex justify-center">
      <div className="flex items-center justify-center bg-[#F2ECE2] rounded-lg w-fit">
        <div className="px-3 py-2 border-r border-r-[#D3CCBE] text-center text-gray-600 flex items-center justify-center gap-1 sm:gap-2">
          <span className="text-[#676767] font-monaMedium text-sm sm:text-lg">
            Powered by:
          </span>
          <div className="flex items-center gap-2">
            <img
              src={logo}
              alt="logo - stagepanda"
              className="w-5 h-5 sm:w-6 sm:h-6"
            />
            <span className="text-orange-600 font-monaSemiBold text-sm sm:text-base">
              Stagepanda
            </span>
          </div>
        </div>

        <div className="px-3 py-2 flex justify-center gap-4 items-center">
          <a
            href="https://www.facebook.com/thestagepanda"
            target="_blank"
            rel="noopener noreferrer"
            className=""
            aria-label="Visit Stagepanda on Facebook"
          >
            <FacebookFilledIcon fill="#20242A" />
          </a>
          <a
            href="https://www.instagram.com/thestagepanda"
            target="_blank"
            rel="noopener noreferrer"
            className=""
            aria-label="Visit Stagepanda on Instagram"
          >
            <InstagramFilledIcon fill="#20242A" />
          </a>

          <a
            href="https://x.com/thestagepanda"
            target="_blank"
            rel="noopener noreferrer"
            className=""
            aria-label="Visit Stagepanda on LinkedIn"
          >
            <XTwitterIcon fill="#20242A" />
          </a>
        </div>
      </div>
    </footer>
  );
}
